import {
  CarrierInfoDTO,
  CreateProducerDTO,
  ProducerDTO,
  UpdateProducerDTO
} from '../types/data/producer-management.type';

import { ApiUtils } from '../utils/api.utils';
import { UrlConstants } from '../constants/url.constants';
import axios from 'axios';

export class ProducerService {
  // Get all producers
  static async getAllProducers(): Promise<ProducerDTO[]> {
    const response = await axios.get(
      UrlConstants.GET_ALL_PRODUCERS,
      ApiUtils.getHeaders()
    );
    return response.data.data;
  }

  // Get producer by ID
  static async getProducerById(id: string): Promise<ProducerDTO> {
    const url = UrlConstants.GET_PRODUCER_BY_ID.replace(':id', id);
    const response = await axios.get(url, ApiUtils.getHeaders());
    return response.data.data;
  }

  // Create new producer
  static async createProducer(
    producerData: CreateProducerDTO
  ): Promise<ProducerDTO> {
    const response = await axios.post(
      UrlConstants.CREATE_PRODUCER,
      producerData,
      ApiUtils.getHeaders()
    );
    return response.data.data;
  }

  // Update producer
  static async updateProducer(
    id: string,
    producerData: UpdateProducerDTO
  ): Promise<ProducerDTO> {
    const url = UrlConstants.UPDATE_PRODUCER.replace(':id', id);
    const response = await axios.patch(
      url,
      producerData,
      ApiUtils.getHeaders()
    );
    return response.data.data;
  }

  // Delete producer
  static async deleteProducer(id: string): Promise<void> {
    const url = UrlConstants.DELETE_PRODUCER.replace(':id', id);
    await axios.delete(url, ApiUtils.getHeaders());
  }

  // Get available carriers
  static async getAvailableCarriers(): Promise<CarrierInfoDTO[]> {
    const response = await axios.get(
      UrlConstants.GET_AVAILABLE_CARRIERS,
      ApiUtils.getHeaders()
    );
    return response.data.data;
  }
}
